module.exports = __webpack_public_path__ + "/images/logo-fr-orchestra.04ef63f.png";